import { render, staticRenderFns } from "./SaveReportWizardBordeauxStatusFilters.vue?vue&type=template&id=85b1c352"
import script from "./SaveReportWizardBordeauxStatusFilters.vue?vue&type=script&lang=js"
export * from "./SaveReportWizardBordeauxStatusFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports